import { getAccessToken } from "../lib/auth";
import { parseApiError } from "../lib/api-error";
import type { KeycloakGroup, KeycloakUser } from "./users";

const API_BASE = "/api";

async function fetchAPI<T>(endpoint: string, options?: RequestInit): Promise<T> {
  const token = await getAccessToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options?.headers as Record<string, string>),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(`${API_BASE}${endpoint}`, { ...options, headers });
  if (!response.ok) {
    throw await parseApiError(response);
  }
  return response.json();
}

export const groupsApi = {
  list: () => fetchAPI<{ groups: KeycloakGroup[] }>("/groups"),

  get: (id: string) => fetchAPI<{ group: KeycloakGroup }>(`/groups/${id}`),

  getChildren: (id: string) =>
    fetchAPI<{ children: KeycloakGroup[] }>(`/groups/${id}/children`),

  getMembers: (id: string, params?: { first?: number; max?: number }) => {
    const qs = new URLSearchParams();
    if (params?.first !== undefined) qs.set("first", String(params.first));
    if (params?.max !== undefined) qs.set("max", String(params.max));
    const q = qs.toString();
    return fetchAPI<{ members: KeycloakUser[] }>(
      `/groups/${id}/members${q ? `?${q}` : ""}`,
    );
  },

  addMember: (groupId: string, userId: string) =>
    fetchAPI<{ ok: boolean }>(`/users/${userId}/groups/${groupId}`, {
      method: "PUT",
    }),

  removeMember: (groupId: string, userId: string) =>
    fetchAPI<{ ok: boolean }>(`/users/${userId}/groups/${groupId}`, {
      method: "DELETE",
    }),
};
